// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader_wrap__Ks4zf {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1001;
  background-color: #F6F7F8;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Loader_loader__XrT2f {
  color: var(--accent-color);
  font-size: 10px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: Loader_mulShdSpin__GXqnS 1.3s infinite linear;
  transform: translateZ(0);
}

@keyframes Loader_mulShdSpin__GXqnS {
  0%, 100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Assets/Loader/Loader.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,0BAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,wDAAA;EACA,wBAAA;AACF;;AAEA;EACE;IAEE,qIAAA;EAAF;EAMA;IACE,mIAAA;EAJF;EASA;IACE,qIAAA;EAPF;EAaA;IACE,yIAAA;EAXF;EAeA;IACE,uIAAA;EAbF;EAiBA;IACE,mIAAA;EAfF;EAmBA;IACE,yIAAA;EAjBF;EAqBA;IACE,oIAAA;EAnBF;AACF","sourcesContent":[".wrap {\r\n  position: fixed;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  z-index: 1001;\r\n  background-color: #F6F7F8;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.loader {\r\n  color: var(--accent-color);\r\n  font-size: 10px;\r\n  width: 1em;\r\n  height: 1em;\r\n  border-radius: 50%;\r\n  position: relative;\r\n  text-indent: -9999em;\r\n  animation: mulShdSpin 1.3s infinite linear;\r\n  transform: translateZ(0);\r\n}\r\n\r\n@keyframes mulShdSpin {\r\n  0%,\r\n  100% {\r\n    box-shadow: 0 -3em 0 0.2em,\r\n    2em -2em 0 0em, 3em 0 0 -1em,\r\n    2em 2em 0 -1em, 0 3em 0 -1em,\r\n    -2em 2em 0 -1em, -3em 0 0 -1em,\r\n    -2em -2em 0 0;\r\n  }\r\n  12.5% {\r\n    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em,\r\n    3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em,\r\n    -2em 2em 0 -1em, -3em 0 0 -1em,\r\n    -2em -2em 0 -1em;\r\n  }\r\n  25% {\r\n    box-shadow: 0 -3em 0 -0.5em,\r\n    2em -2em 0 0, 3em 0 0 0.2em,\r\n    2em 2em 0 0, 0 3em 0 -1em,\r\n    -2em 2em 0 -1em, -3em 0 0 -1em,\r\n    -2em -2em 0 -1em;\r\n  }\r\n  37.5% {\r\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,\r\n    3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em,\r\n    -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;\r\n  }\r\n  50% {\r\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,\r\n    3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em,\r\n    -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;\r\n  }\r\n  62.5% {\r\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,\r\n    3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0,\r\n    -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;\r\n  }\r\n  75% {\r\n    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em,\r\n    3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em,\r\n    -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;\r\n  }\r\n  87.5% {\r\n    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em,\r\n    3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em,\r\n    -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Loader_wrap__Ks4zf`,
	"loader": `Loader_loader__XrT2f`,
	"mulShdSpin": `Loader_mulShdSpin__GXqnS`
};
export default ___CSS_LOADER_EXPORT___;
